module.exports = __webpack_public_path__ + "img/ceo_way_tip_04.ad34f3d8.png";